export default __webpack_public_path__ + "static/Suzanne_Bakx_1-653c1c9dd4722e986f611812c722a790.jpg";